/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_StartInputs */

const en_entity_start = /** @type {(inputs: Entity_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const de_entity_start = /** @type {(inputs: Entity_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

/**
* | output |
* | --- |
* | "Start" |
*
* @param {Entity_StartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_start = /** @type {((inputs?: Entity_StartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_StartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_start(inputs)
	return de_entity_start(inputs)
});